module.exports = __webpack_public_path__ + "images/tips/inspiration-1@2x.537647bd716153a10a32.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/inspiration-1@2x.png
// module id = Npj9
// module chunks = 1